import { isTag, isDocumentNode } from 'anodum';
import constants from '../constants';
import isElementDetached from '../verifiers/is-element-detached';

const ejectGlobals = (staticNode) => {
  const rootElement = staticNode;

  if (
    !isDocumentNode(staticNode) &&
    isTag(rootElement, constants.GLOBAL_TAG_NAME) &&
    !isElementDetached(rootElement)
  ) {
    rootElement.innerHTML = '';
  } else {
    const globalElements = rootElement.querySelectorAll(constants.GLOBAL_TAG_NAME);

    globalElements.forEach((globalElement) => {
      const element = globalElement;
      if (!element || isElementDetached(element)) {
        return;
      }

      element.innerHTML = '';
    });
  }

  return staticNode;
};

export default ejectGlobals;
